import { getFontVariantWeight, isItalicFontVariant } from '../../../../services/font';

export function isItemChecked(variant, selectedWeights) {
  return selectedWeights
    .filter((currentWeight) => !isItalicFontVariant(currentWeight))
    .map((currentWeight) => getFontVariantWeight(currentWeight))
    .includes(getFontVariantWeight(variant));
}
